import { ResultStatus } from '../../models/test-run.model';
import { ReportTestItem } from '../../dashboard/ci-mapping/ci-mapping.model';

export type ReportTestStatusKind = 'passed' | 'failed' | 'skipped' | 'other';

export interface ReportTestStatusMark {
  kind: ReportTestStatusKind;
  icon: string;
}

const STATUS_MARKS: Partial<Record<ResultStatus, ReportTestStatusMark>> = {
  PASSED: { kind: 'passed', icon: 'check' },
  FAILED: { kind: 'failed', icon: 'close' },
  SKIPPED: { kind: 'skipped', icon: 'remove' },
};
const OTHER_MARK: ReportTestStatusMark = { kind: 'other', icon: 'more_horiz' };

export function reportTestStatusMark(status: ResultStatus | null): ReportTestStatusMark {
  return (status && STATUS_MARKS[status]) ?? OTHER_MARK;
}

export function reportTestClassname(item: Pick<ReportTestItem, 'name' | 'matchKey'>): string | null {
  for (const separator of ['#', '.']) {
    const suffix = separator + item.name;
    if (item.matchKey.length > suffix.length && item.matchKey.endsWith(suffix)) {
      return item.matchKey.slice(0, -suffix.length);
    }
  }
  return item.matchKey === item.name ? null : item.matchKey;
}

export function reportTestTime(durationMs: number | null): string {
  return durationMs === null ? '—' : `${(durationMs / 1000).toFixed(2)}s`;
}
